import { Language } from "../types/language";

export const formatDistance = (val: number, lang: Language): string => {
  return new Intl.NumberFormat(`${lang}-CA`, { style: 'unit', unit: 'kilometer', unitDisplay: 'short', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(val);
};